import { createAction, props } from '@ngrx/store';
import { OffersFilters, OffersMap } from './offers.model';
import { Location } from '../../services/locations/location.model';
import { Offer } from '../../services/offers/offer.model';
import { OffersType } from '@toevla-webapplications/core';
import { User } from '../../services/user/user.model';

const setFilters = createAction('[Offers] Set filter', props<{ filters: Partial<OffersFilters> }>());
const setLocations = createAction('[Offers] Set locations', props<{ locations: Location[] }>());
const setOrder = createAction('[Offers] Set order', props<{ name: string; asc: boolean; sort: string }>());
const setType = createAction('[Offers] Set type', props<{ t: OffersType }>());
const clearSideFilters = createAction('[Offers] Clear side filters');
const clearSideFilterValue = createAction('[Offers] Clear side filter value', props<{ name: string; value: string }>());
const setMaxPrices = createAction('[Offers] Set max prices', props<{ maxPriceAccommodation: number; maxPriceDaytrip: number }>());

const addOffers = createAction('[Offers] Add offers', props<{ offers: Offer[]; total: number }>());
const clearOffers = createAction('[Offers] Clear offers');
const loadingOffers = createAction('[Offers] Offers loading', props<{ loading: boolean }>());

const setUser = createAction('[Offers] Set user', props<{ user: User | null }>());

const setView = createAction('[Offers] Set view', props<{ view: 'list' | 'map' }>());
const setMap = createAction('[Offers] Set map', props<{ options: OffersMap }>());

const OFFERS_ACTIONS = {
	setFilters,
	setLocations,
	setOrder,
	setType,
	clearSideFilters,
	clearSideFilterValue,
	setMaxPrices,

	addOffers,
	clearOffers,
	loadingOffers,

	setUser,

	setView,
	setMap,
};

export default OFFERS_ACTIONS;
